import { createUseStyles, ComposedTheme } from '@glu/theming';

const styles = ({ dataComponents: { rowActions } }: ComposedTheme) => ({
  wrap: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },
  firstAction: {
    paddingRight: 8,
    borderRight: `${rowActions.firstActionBorderColor} 1px solid`,
  },
  iconWrap: {
    display: 'flex',
  },
  popover: {
    margin: 0,
    padding: [8, 0],
    minWidth: 200,
  },
  menuButton: {
    fontFamily: rowActions.menuButton.text.font.fontFamily,
    display: 'block',
    padding: 8,
    lineHeight: '24px',
    color: rowActions.menuButton.text.color,
    width: '100%',
    textAlign: 'left',
    '&:focus, &:hover': {
      textDecoration: 'none',
    },
    '&:hover': {
      backgroundColor: rowActions.menuButton.hoverColor,
    },
  },
  icon: {
    background: 'transparent',
    cursor: 'pointer',
  },
});

export default createUseStyles(styles);
